<!--产品税率-->
<template>
  <div class="productTax">
    <el-row>
      <el-col>
        <el-form :inline="true" style="margin: 0;" :model="searchForm" ref="searchForm" @keyup.enter.native="queryList">
          <el-form-item label="分类名称：">
            <el-input size="medium" v-model="searchForm.CATALOG_NAME"></el-input>
          </el-form-item>
          <el-form-item label="供应商：" v-if="activeName == 'supplierTax'">
            <el-select size="medium" filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择供应商"
              style="width: 100%" clearable>
              <el-option v-for="item in supplierList" :key="item.index" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 10px">
      <el-button size="medium" type="primary" @click="queryList">筛选</el-button>
      <el-button size="medium" style="color: rgb(96,98,102)" @click="clearSearch" type="text">重置筛选条件</el-button>
    </el-row>
    <div class="middle">
      <el-button size="medium" @click="addKind">新增</el-button>
    </div>
    <el-tabs type="border-card" style="background:white" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="供应商税率设置" name="supplierTax" lazy>
        <V-supplierTax ref="supplierTax" :search-form="searchForm" @getSupplierList="getSupplierList($event)">
        </V-supplierTax>
      </el-tab-pane>
      <el-tab-pane label=" 分类税率设置" name="kindTax" lazy>
        <V-kindTax ref="kindTax" :search-form="searchForm"></V-kindTax>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VSupplierTax from './supplierTax';
import VKindTax from './kindTax';

export default {
  data() {
    return {
      activeName: 'supplierTax',
      activeNameList: ['supplierTax', 'kindTax'],
      searchForm: {},
      newTcList: [],
      supplierList: [],
    };
  },
  components: {
    VSupplierTax,
    VKindTax,
  },
  methods: {
    handleClick(tab, event) {
      sessionStorage.setItem('activeName', this.activeName);
    },
    getActiveName() {
      if (sessionStorage.getItem('activeName')) {
        const Name = this.activeNameList.find((item) => item === sessionStorage.getItem('activeName'));
        if (Name) {
          this.activeName = Name;
        }
      }
    },
    queryList() {
      this.$refs[this.activeName].queryList();
    },
    addKind() {
      this.$refs[this.activeName].addKind();
    },
    getSupplierList(data) {
      this.supplierList = data;
    },
    clearSearch() {
      this.searchForm = {};
    },
  },
  created() {
    this.getActiveName();
  },
};
</script>

<style scoped>
.productTax {
  width: 100%;
}

.productTax>>>.el-tabs__item {
  padding-left: 20px !important;
  width: 140px !important;
}

.productTax>>>.el-tabs__item .is-top {
  width: 140px !important;
}

.productTax>>>.el-tabs__nav-wrap::after {
  height: 1px !important;
}

.middle {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f7f9;
  padding: 0 20px;
  margin: 0 -20px 20px -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SKUManage/productTax.vue